import { useEffect, useState } from 'react';

import { Spinner } from '../../common/components';
import { fetchIssuePhotoUrl } from '../services/IssueService';
import { IssuePhoto } from '../types';

interface IssuePhotoGalleryProps {
  issueId: string;
  photos: IssuePhoto[];
}

/**
 * Náhledy fotek hlášení. Fotky se stahují autorizovaně (axios blob) a zobrazují
 * přes object URL; kliknutí otevře plnou velikost v novém tabu.
 */
export const IssuePhotoGallery: React.FC<IssuePhotoGalleryProps> = ({ issueId, photos }) => {
  const [urls, setUrls] = useState<Record<string, string>>({});

  useEffect(() => {
    let cancelled = false;
    const loaded: string[] = [];

    photos.forEach((photo) => {
      fetchIssuePhotoUrl(issueId, photo)
        .then((url) => {
          loaded.push(url);
          if (!cancelled) setUrls((prev) => ({ ...prev, [photo.id]: url }));
        })
        .catch(() => undefined);
    });

    return () => {
      cancelled = true;
      loaded.forEach((url) => URL.revokeObjectURL(url));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [issueId]);

  if (photos.length === 0) return null;

  return (
    <div className="IssuePhotos">
      {photos.map((photo) => {
        const url = urls[photo.id];
        return (
          <button
            key={photo.id}
            type="button"
            className="IssuePhotos__item"
            onClick={() => url && window.open(url, '_blank')}
            aria-label={photo.filename}
          >
            {url ? <img src={url} alt={photo.filename} /> : <Spinner />}
          </button>
        );
      })}
    </div>
  );
};

export default IssuePhotoGallery;
